<button
  [class]="buttonClasses"
  [attr.type]="submit ? 'submit' : 'button'"
>
  <ng-content></ng-content>
</button>
